// extracted by mini-css-extract-plugin
export default {"addSlot":"SlotList_addSlot__-s+WW","panelList":"SlotList_panelList__0UsqZ","addFirstSlot":"SlotList_addFirstSlot__e37gG","placeholder":"SlotList_placeholder__EQ9Vd"};